const _0 = "0deg"
const _15 = "15deg"
const _30 = "30deg"
const _60 = "60deg"
const _90 = "90deg"
const _180 = "180deg"
const config = { "0": _0, "15": _15, "30": _30, "60": _60, "90": _90, "180": _180,  }
export { config as default, _0, _15, _30, _60, _90, _180 }